import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';

import { Root } from '../styles.tsx';

export const RewardUnlockedStoryLoading = () => (
  <Root className="hideBackground">
    <LoadingIndicator />
  </Root>
);
